export const RESIGN_RESPONSE_TIMEOUT_MS = 6_000;

type ResignPhase = 'idle' | 'pending' | 'terminal';

/**
 * Tracks a resign request without guessing the result locally. The table remains active until the
 * server either rejects/settles the request or sends the authoritative terminal result.
 */
export class ResignLifecycle {
  private phase: ResignPhase = 'idle';

  get isPending(): boolean {
    return this.phase === 'pending';
  }

  get isTerminal(): boolean {
    return this.phase === 'terminal';
  }

  /** Begin one request, suppressing duplicate taps while it is in flight or after match end. */
  begin(): boolean {
    if (this.phase !== 'idle') return false;
    this.phase = 'pending';
    return true;
  }

  /** Settle a pending request after a non-terminal server response or local send failure/timeout. */
  acknowledge(): boolean {
    if (this.phase !== 'pending') return false;
    this.phase = 'idle';
    return true;
  }

  /** Enter terminal state once; duplicate end-game packets are intentionally ignored. */
  complete(): boolean {
    if (this.phase === 'terminal') return false;
    this.phase = 'terminal';
    return true;
  }
}
